import React, { Component } from "react";
import s from "../Calendar.css";
import cx from "classnames";

class CalendarScrollButtons extends Component {
  render() {
    const { canScrollLeft, canScrollRight, onLeftClick, onRightClick } =
      this.props;

    return (
      <>
        {canScrollLeft && (
          <button
            className={cx(
              s.positionAbsolute,
              s.top0,
              s.bottom0,
              s.dFlex,
              s.alignItemsCenter,
              s.px2,
              s.arrowIcon,
              s.ArrowLeft
            )}
            onClick={onLeftClick}
          >
            <span className={s.iconArrow}>‹</span>
          </button>
        )}

        {canScrollRight && (
          <button
            className={cx(
              s.positionAbsolute,
              s.top0,
              s.bottom0,
              s.end0,
              s.dFlex,
              s.alignItemsCenter,
              s.px2,
              s.arrowIcon
            )}
            onClick={onRightClick}
          >
            <span className={s.iconArrow}>›</span>
          </button>
        )}
      </>
    );
  }
}

export default CalendarScrollButtons;
